"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("mktUpDownCaret", function () {
  return {
    scope: {
      down: "<"
    },
    restrict: "E",
    replace: true,
    template: '<i class="mkt-up-down-caret fa {{down ? \'fa-caret-down\' : \'fa-caret-up\'}}"></i>',
    link: function link($scope, $el, $attrs) {}
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/marche/dashboard/mkt-up-down-caret.js
// module id = 2839
// module chunks = 13